import { ReduxAction } from '../actions';
import { ActionTypes } from './actions';
import { InstitutionUsageState, INITIAL_STATE } from './state';
import { InstitutionMonthlyUsageDataResponseKind } from './types';

export const InstitutionUsage = (
  state: InstitutionUsageState = INITIAL_STATE,
  action: ReduxAction
): InstitutionUsageState => {
  switch (action.type) {
    case ActionTypes.MONTHLY_USAGE_SUMMARY_LOAD_START: {
      return {
        ...state,
        monthlyUsageSummary: {
          value: {
            monthlyUsages: [],
            subscriptionId: '',
          },
          ...state.monthlyUsageSummary,
          kind: InstitutionMonthlyUsageDataResponseKind.loading,
        },
      };
    }
    case ActionTypes.MONTHLY_USAGE_SUMMARY_LOAD_SUCCESS: {
      const { subscriptionId, monthlyUsages } = action.data;
      return {
        ...state,
        monthlyUsageSummary: {
          kind: InstitutionMonthlyUsageDataResponseKind.success,
          value: {
            subscriptionId,
            monthlyUsages,
          },
        },
      };
    }
    case ActionTypes.MONTHLY_USAGE_SUMMARY_LOAD_FAIL: {
      return {
        ...state,
        monthlyUsageSummary: {
          kind: InstitutionMonthlyUsageDataResponseKind.forbidden,
        },
      };
    }
    case ActionTypes.INSTITUTION_BILLING_CYCLE_USAGE_LOAD_SUCCESS: {
      return {
        ...state,
        subscriptionId: action.data.subscriptionId,
        billingCycleUsageSummary: action.data,
      };
    }
    case ActionTypes.BILLING_PERIODS_LOAD: {
      return {
        ...state,
        billingPeriodSummary: {
          billingPeriods: action.data,
        },
      };
    }
    case ActionTypes.USAGE_FOR_SUBSCRIPTION_LOAD_SUCCESS:
      return {
        ...state,
        usageForSubscription: action.data,
      };
    default: {
      return state;
    }
  }
};
